import AgencyHelper, { AgencyConstants } from 'features/Agency/agencyHelper';
import { AnimatePresence, motion } from 'framer-motion';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import VITableRowDropDown from 'general/components/VITableRowDropDown';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import GroupReconciliationView from './components/GroupReconciliationView';
import SaleReconciliationView from './components/SaleReconciliationView';

AgencyReconciliationDetailView.propTypes = {
  reconciliationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  agencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function AgencyReconciliationDetailView(props) {
  // MARK: ---- PROPERTIES ----
  const { reconciliationId, agencyId } = props;
  const { user } = useSelector((state) => state.auth);
  const isAdmin = user?.role === 'ADMIN' || user?.role === 'OPERATOR';
  const [reconciliationDetail, setReconciliationDetail] = useState(null);
  const [month, setMonth] = useState(null);
  const router = useRouter();
  useEffect(() => {
    if (reconciliationId) {
      AgencyHelper.API.requestGetReconciliationDetail(reconciliationId).then(
        (reconciliationDetail) => {
          setReconciliationDetail(reconciliationDetail);
        }
      );
    } else if (agencyId) {
      const paramGetReconciliationList = {
        agencyId,
      };
      AgencyHelper.API.requestGetReconciliationList(paramGetReconciliationList).then(
        (reconciliationList) => {
          setReconciliationDetail(_.maxBy(reconciliationList, 'reconciliationId'));
        }
      );
    }
  }, [reconciliationId, agencyId]);
  useEffect(() => {
    if (reconciliationDetail) {
      setMonth(reconciliationDetail?.month);
    }
  }, [reconciliationDetail]);

  // MARK: ---- METHODS ----
  const handlePrintReport = () => {
    const document = reconciliationDetail?.document;
    if (document) {
      Utils.openInNewTab(document);
    }
  };
  const buildMoreActions = (reconciliationDetail) => {
    const actions = [];
    actions.push({
      text: 'Ký đối soát',
      iconElement: <i className="fa-regular fa-file-signature" style={{ fontSize: '1.1rem' }} />,
      click: () => {},
    });
    if (isAdmin) {
      if (AgencyHelper.Utils.checkReconciliationCanEdit(reconciliationDetail?.status)) {
        actions.push({
          text: 'Chỉnh sửa đối soát',
          iconElement: <i className="fa-regular fa-edit" style={{ fontSize: '1.1rem' }} />,
          click: () => {},
        });
      }
      if (AgencyHelper.Utils.checkReconciliationCanDelete(reconciliationDetail?.status)) {
        actions.push({
          text: 'Xoá đối soát',
          iconElement: <i className="fa-regular fa-trash-can" style={{ fontSize: '1.1rem' }} />,
          click: () => {
            AgencyHelper.UI.showDialogConfirmDeleteReconciliation(reconciliationDetail, () => {
              router.navigate(-1);
            });
          },
        });
      }
    }
    return actions;
  };

  return (
    <div>
      {/* breadcrumb */}
      <div>
        {UIHelper.buildBreadcrumb([
          {
            title: 'Báo cáo đối soát',
            onPress: () => {
              router.navigate(-1);
            },
          },
          { title: 'Chi tiết đối soát' },
        ])}
      </div>

      <div className="px-4 mt-4 pb-4">
        {UIHelper.buildCard(
          <div>
            {/* header */}
            <div
              className="px-5 py-4 d-flex align-items-center justify-content-between"
              style={{ borderBottom: `1px solid ${AppColors.gray[300]}` }}
            >
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-2">
                  <span style={UIHelper.buildFontStyle('600', '18px', AppColors.gray[800])}>
                    {reconciliationDetail?.agency?.name}
                  </span>
                  <KTLabel
                    text={AgencyHelper.Utils.getReconciliationStatusName(
                      reconciliationDetail?.status
                    )}
                    isInline={true}
                    size={KTLabelSize.medium}
                    additionalClassName={`label-light-${AgencyHelper.Utils.getReconciliationStatusColor(
                      reconciliationDetail?.status
                    )}`}
                  />
                </div>
                <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}>
                  {AgencyHelper.Utils.getReconciliationRoleName(reconciliationDetail?.forRole)}{' '}
                  tháng{' '}
                  <span style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[800])}>
                    {Utils.formatDateTimeToString(reconciliationDetail?.month, 'MM/YYYY')}
                  </span>
                </span>
              </div>

              {/* actions */}
              <div className="d-flex align-items-center gap-2">
                {/* loc theo thang doi soat */}
                {/* <KTFormInput
                  name="month"
                  type={KTFormInputType.month}
                  value={month}
                  onChange={(value) => {
                    setMonth(value);
                  }}
                /> */}
                {/* xuat bao cao */}
                {UIHelper.buildBlueButton(
                  'Xuất báo cáo',
                  handlePrintReport,
                  <i className="fa-regular fa-file-export" />
                )}
                <VITableRowDropDown
                  toggleElement={
                    <a className="btn btn-sm btn-clean btn-icon h-45px w-45px btn-light">
                      <i
                        className="fa-solid fa-ellipsis"
                        style={{ color: AppColors.gray[700], fontSize: '1.1rem' }}
                      />
                    </a>
                  }
                  menuItem={buildMoreActions(reconciliationDetail)}
                />
              </div>
            </div>
            {/* body */}
            <div>
              <AnimatePresence mode="wait">
                <motion.div
                  key={reconciliationDetail?.forRole}
                  initial={{ y: 10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  exit={{ y: -10, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                >
                  {reconciliationDetail?.forRole ===
                    AgencyConstants.AgencyReconciliationRole.GROUP && (
                    <div>
                      <GroupReconciliationView reconciliationDetail={reconciliationDetail} />
                    </div>
                  )}
                  {reconciliationDetail?.forRole ===
                    AgencyConstants.AgencyReconciliationRole.SALE && (
                    <div>
                      <SaleReconciliationView reconciliationDetail={reconciliationDetail} />
                    </div>
                  )}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>,
          true
        )}
      </div>
    </div>
  );
}

export default AgencyReconciliationDetailView;
